import ProductManage from './index';
import Category from './Category/category';
import Selection from './Selection/selection';
import Recommedn from './Recommend/recommend';

export default {
    path : '/Product',
    component: ProductManage,
    children:[
        {path: '/product/category',component: Category},
        {path: '/product/selection',component: Selection},
        {path: '/product/recommend',component: Recommedn},
    ]
}